"use client";

import React from "react";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { Menu, ArrowLeft } from "lucide-react";
import { PolicyLink } from "./policy-links";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { cn } from "@/lib/utils";

export default function PolicySidebar({ links }: { links: PolicyLink[] }) {
  const path = usePathname();
  const router = useRouter();

  return (
    <div className="w-full">
      {/* Mobile Top Bar */}
      <div className="flex items-center justify-between py-4 px-4 md:hidden">
        <button aria-label="Back" onClick={() => router.back()} className="py-2">
          <ArrowLeft size={24} />
        </button>
        <Drawer>
          <DrawerTrigger asChild>
            <button aria-label="Menu" className="py-2">
              <Menu size={24} />
            </button>
          </DrawerTrigger>

          <DrawerContent className="px-3 text-sm">
            <DrawerHeader>
              <DrawerTitle>Policy Documents</DrawerTitle>
              <div className="sticky top-0 z-20 flex w-full items-center justify-center bg-inherit">
                <div className="my-3 h-1.5 w-16 rounded-full bg-muted-foreground/20" />
              </div>
            </DrawerHeader>
            {links.map((item) => {
              const isActive = path === item.href;
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={cn(
                    "text-lg flex justify-center items-center my-1 transition-colors",
                    isActive
                      ? "bg-blue-100 font-bold rounded-full py-3"
                      : "hover:bg-gray-100 font-normal py-3"
                  )}
                >
                  {item.label}
                </Link>
              );
            })}
          </DrawerContent>
        </Drawer>
      </div>
      {/* Desktop sidebar */}
      <nav className="hidden md:flex w-full flex-col gap-1 px-4 md:block pt-8">
        {links.map((item) => {
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex gap-3 rounded-md p-2 text-sm font-medium ${
                path === item.href ? "bg-sky-700 text-secondary" : "text-muted-foreground"
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
